import {
  RoutineWorkflow,
  useCurrentWorkspace,
  useRoutineAlerts,
} from '@gripp/shared-logic';
import {
  AlertSummary,
  LoadingIndicator,
  tokens,
} from '@gripp/shared-ui';
import { ScrollView, StyleSheet, View } from 'react-native';

type ProductAlertListProps = {
  productId: string;
  routineId: string;
  onAlertSelected: (alert: RoutineWorkflow) => void;
};

export const ProductAlertList = ({
  productId,
  routineId,
  onAlertSelected,
}: ProductAlertListProps) => {
  const currentWorkspace = useCurrentWorkspace();
  const { routineWorkflows, isLoading } = useRoutineAlerts(
    '',
    routineId,
    productId,
    { enabled: !!currentWorkspace }
  );

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <LoadingIndicator flexContainer />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ScrollView>
        {routineWorkflows?.map((item: RoutineWorkflow, index: number) => (
          <AlertSummary
            key={`${index}-${item.id}`}
            workflow={item}
            routineId={routineId}
            onAlertSelected={onAlertSelected}
          />
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: tokens.spacing.xl,
  },
  loadingContainer: {
    margin: tokens.spacing.xl,
  },
});
